(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-items"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(e) {
  const btn = e.target.closest('.collection-items__ficha-btn');
  if (btn) {
    const modal = document.getElementById(btn.dataset.modal);
    if (modal) modal.removeAttribute('hidden');
    return;
  }

  const closeBtn = e.target.closest('.collection-items__modal-close');
  if (closeBtn) {
    closeBtn.closest('.collection-items__modal').setAttribute('hidden', '');
    return;
  }

  if (e.target.classList.contains('collection-items__modal')) {
    e.target.setAttribute('hidden', '');
  }
});

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    document.querySelectorAll('.collection-items__modal:not([hidden])').forEach(function(m) {
      m.setAttribute('hidden', '');
    });
  }
});
  } catch(e) { console.error(e); }
})();

})();
